module.exports = __webpack_public_path__ + "static/qr_code_wa_chat_staging-669e9464d53963e8eb3a5930debeab7f.png";